import {EnvAppInfoContainer} from '@hconnect/uikit'
import React from 'react'

import Footer from '../components/Footer'

export default function FooterContainer() {
  return (
    <Footer>
      <EnvAppInfoContainer />
    </Footer>
  )
}
